import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { TranscriptionModel, TranscriptionModels } from 'src/app/shared/components/recorders/audio-recorder/audio-recorder.dto';
import { ConfigurationService } from 'src/app/shared/services/configuration.service';

@Component({
  selector: 'app-speech-model',
  imports: [TranslateModule, FormsModule, MatFormFieldModule, MatSelectModule],
  template: `
    <div class="d-flex gap-3 flex-grow-1">
      <mat-form-field appearance="outline" class="flex-grow-1">
        <mat-label>{{ 'SpeechModel.Label.DictationModel' | translate }}</mat-label>
        <mat-select [value]="transcriptionModel" (selectionChange)="setLiveTranscriptionModels($event)">
          @for (model of liveTranscriptionModels; track model) {
            <mat-option [value]="model.value">
              {{ model.view | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  `,
  styleUrls: ['./speech-model.component.scss'],
})
export class SpeechModelComponent implements OnInit {
  private configService = inject(ConfigurationService);
  private unsubscribe$ = new Subject<void>();

  loading = false;
  liveTranscriptionModels = [{ view: 'SpeechModel.Model.Chirp3', value: TranscriptionModels.CHIRP3 }];
  transcriptionModel: TranscriptionModel = TranscriptionModels.CHIRP3;

  ngOnInit(): void {
    this.configService
      .getConfigValue('transcriptionSettings')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((settings) => {
        if (settings && settings.model) {
          this.transcriptionModel = settings.model;
        } else {
          this.transcriptionModel = TranscriptionModels.CHIRP3;
        }
      });
  }

  async setLiveTranscriptionModels(event: { value: TranscriptionModel }): Promise<void> {
    try {
      await this.configService.updateConfig({ transcriptionSettings: { model: event.value } });
    } catch (error) {
      console.error('Failed to update transcription model', error);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
